import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { ReactComponent as IconComment } from 'images/new-icons/comment-icon.svg';
import { ReactComponent as IconHeartFilled } from 'images/heart-filled.svg';
import { ReactComponent as IconHeart } from 'images/new-icons/like-icon.svg';
import { ReactComponent as IconMore } from 'images/more.svg';
import { ReactComponent as IconShare } from 'images/new-icons/share-icon.svg';
import { ReactComponent as IconEye } from 'images/new-icons/views-eye.svg';
import { useActions } from 'store/useActions';
import { useLike } from 'sdk/hooks/useLike';
import useActivitiesCount from 'sdk/hooks/useActivitiesCount';
import useUserActivities from 'sdk/hooks/user/useUserActivities';
import ShareModal from './ShareModal';
import { useNavigate } from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import { useTranslation } from 'react-i18next';
function ActionButtons({
  currentUser,
  styles,
  post,
  setSignUpVisible,
  commentCount,
  props,
  id,
  openDrawer,
  openComments,
  setIsShareModalOpen,
}) {
 
  const {t} = useTranslation() as any;
  const { setIsGetAppModal } = useActions();
  const { addLike, removeLike, isLoading } = useLike();
  const [likesCount, setLikesCount] = useState(0);
  const { setIsButtonMenuVisible } = useActions();
  const { data: likeCountData, isFetched: likeCountFetched } = useActivitiesCount(post?.id, 'like');

  const navigate = useNavigate();
  const { data: isAuthData } = useIsAuth();

  const {
    data: userActivities,
    isSuccess: activitiesLoaded,
    refetch: refetchActivities,
  } = useUserActivities(currentUser?.id, post?.id);

  const hasOwnLike = userActivities?.some(activity => activity.type === 'like');
  const ownLikeId = userActivities?.find(activity => activity.type === 'like')?.id;
 
  useEffect(() => {
    if (likeCountFetched) {
      setLikesCount(likeCountData || 0);
    }
  }, [likeCountData]);

  const handleLike = async e => {
    e?.stopPropagation();

    if (!isAuthData?.isAuth) {
      navigate('/sign-up');
      return;
    }

    try {
      if (hasOwnLike) {
        await removeLike({
          postId: post.id,
          userId: currentUser.id,
          likeId: ownLikeId,
        });
      } else {
        await addLike({
          postId: post.id,
          userId: currentUser.id,
        });
      }
      refetchActivities();
    } catch (error) {
      console.error('Error handling like:', error);
    }
  };

  const handleCommentClick = e => {
    e.stopPropagation();
    if (!currentUser) {
      setSignUpVisible(true);
      return;
    }
    openComments();
  };

  return (
    <div className={styles.actionsCol}>
      <div
        className={clsx(styles.action, isLoading && styles.action_disabled)}
        onClick={handleLike}
      >
        {hasOwnLike ? <IconHeartFilled /> : <IconHeart />}
        {likesCount}
      </div>

      <div
        className={styles.action}
        onClick={e => {
          props?.onShowComments(true);
        }}
      >
        <IconComment />
        {commentCount}
      </div>

      <div className={styles.action}>
        <IconEye />
        {post?.views}
      </div>

      <div
        className={styles.action}
        onClick={e => {
          e.stopPropagation();
          if (!isAuthData?.isAuth) {
            navigate('/sign-up');
            return;
          }
          setIsShareModalOpen(true);
        }}
      >
        <IconShare />
      </div>
    </div>
  );
}

export default ActionButtons;
